// Generated by DesignToCode

import { CommonModule } from "@angular/common";
import { Component, input, output, signal, Inject } from "@angular/core";

@Component({
  selector: "app-based",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./based.html",
})
export class Based {
  // Inputs
  // Outputs
}
